import type { TranslationCapabilities } from '@/api/document.api';

export type TranslationView = 'form' | 'submitting' | 'running' | 'succeeded' | 'failed' | 'expired' | 'unknown';
export const mapTranslationStatus = (status?: string): TranslationView => {
  switch ((status || '').toLowerCase()) {
    case 'notstarted': case 'running': return 'running';
    case 'succeeded': return 'succeeded';
    case 'failed': return 'failed';
    case 'expired': return 'expired';
    default: return 'unknown';
  }
};

export interface TranslationSource { name: string; extension?: string; size?: number }

export type TranslationValidationMessage = 'pageLimitExceeded' | 'wordLimitExceeded' | 'measurementUnavailable'
  | 'layoutMeasurementUnavailable' | 'imageTextUnavailable' | 'measurementServiceUnavailable' | 'validationFailed';

export function translationValidationMessage(errors: unknown): TranslationValidationMessage {
  if (!Array.isArray(errors)) return 'validationFailed';
  if (errors.includes('DOCUMENT_PAGE_LIMIT_EXCEEDED')) return 'pageLimitExceeded';
  if (errors.includes('DOCUMENT_WORD_LIMIT_EXCEEDED')) return 'wordLimitExceeded';
  if (errors.includes('DOCUMENT_LAYOUT_MEASUREMENT_UNAVAILABLE')) return 'layoutMeasurementUnavailable';
  if (errors.includes('DOCUMENT_IMAGE_TEXT_UNMEASURED')) return 'imageTextUnavailable';
  if (errors.includes('DOCUMENT_MEASUREMENT_SERVICE_UNAVAILABLE')) return 'measurementServiceUnavailable';
  if (errors.includes('DOCUMENT_MEASUREMENT_UNAVAILABLE')) return 'measurementUnavailable';
  return 'validationFailed';
}

export function translationBlockReason(source: TranslationSource | undefined, capabilities: TranslationCapabilities | null): 'loading' | 'unsupported' | 'tooLarge' | 'batchUnavailable' | null {
  if (!capabilities) return 'loading';
  const ext = (source?.extension || source?.name.split('.').pop() || '').replace(/^\./, '').toLowerCase();
  const format = capabilities.formats.find((item) => item.extension.replace(/^\./, '').toLowerCase() === ext);
  if (!format) return 'unsupported';
  if (source?.size !== undefined && Number.isFinite(source.size) && source.size > format.max_bytes) return 'tooLarge';
  if (format.default_mode === 'batch' && !capabilities.batch_enabled) return 'batchUnavailable';
  return null;
}
